import Vue from 'vue'
import http from 'axios'

http.defaults.baseURL = `${process.env.VUE_APP_ADDRESS_BACKEND}`

Vue.prototype.$http = http

export default http
